import { render, staticRenderFns } from "./TotalMentalHealthYourImpact.vue?vue&type=template&id=7e2280f4"
import script from "./TotalMentalHealthYourImpact.vue?vue&type=script&lang=js"
export * from "./TotalMentalHealthYourImpact.vue?vue&type=script&lang=js"
import style0 from "./TotalMentalHealthYourImpact.vue?vue&type=style&index=0&id=7e2280f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports